export const FOLDER_CLEAR = 'FOLDER_CLEAR';
export const FOLDER_FETCH = 'FOLDER_FETCH';
export const FOLDER_SELECTED = 'FOLDER_SELECTED';
export const FOLDER_NAVIGATE_BACK = 'FOLDER_NAVIGATE_BACK';

export default {
    clear: FOLDER_CLEAR,
    fetch: FOLDER_FETCH,
    selected: FOLDER_SELECTED,
    navigateBack: FOLDER_NAVIGATE_BACK
};
